import { AccountController } from "@/app/core/base/controllers/AccountController";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { ResponseController } from "@/app/core/base/controllers/ResponseController";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import { UserHelper } from "@/app/core/util/helpers/UserHelper";
import { Message } from "@/app/core/util/messages/GeralMessages";
import Storage from "@/app/core/util/Storage";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

export default function ComplainItem({ item, reload }) {
    const userData = Storage.getUserData();
    const [data, setData] = useState({});
    const [company, setCompany] = useState({});
    const [responses, setResponses] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setData(item);
        loadCompany();
        loadResponses();
    }, [item])

    async function loadCompany() {
        if (item.companyId) {
            let company = await CompanyController.Get(item.companyId);
            setCompany(company);
        }
    }

    async function loadResponses() {
        setResponses([]);
        let list = await ResponseController.List(item.id);
        for (let s of list) {
            s.user = await AccountController.GetUser(s.userId);
        }
        list.sort(function (a, b) {
            return b.createdDate.seconds - a.createdDate.seconds;
        });

        setResponses(list);
    }

    async function deleteComplain() {
        if (window.confirm(Message.DeleteConfirm)) {
            setLoading(true)
            await ComplainController.Delete(data.id);
            toast.success(Message.DeleteSuccess);
            setLoading(false)
            reload();
        }
    }

    return (
        <div>
            <div className="block block-fx-pop">
                <div className="block-header"> 
                    {company?.logo && (
                        <img src={company.logo} alt="Company Logo" style={{ maxHeight: 50, marginRight: 10 }} />
                    )}
                    {company && (
                        <h3 className="block-title text-muted font-weight-bold">{company.name}</h3>
                    )}
                    <div className="block-tools">
                        <button className="btn btn-danger" onClick={() => deleteComplain()}><i className="si si-close" /> Excluir Reclamação</button>
                    </div>
                </div>

                <div className="block-content bg-body-light">
                    <div className="py-1" style={{ whiteSpace: "pre-line" }}>
                        <strong style={{ fontWeight: "bold" }}>Título:</strong> {data && data.title}
                    </div>
                    <div className="pb-3" style={{ whiteSpace: "pre-line" }}>
                        <strong style={{ fontWeight: "bold" }}>Descrição:</strong> {data && data.description}
                    </div>
                    <div className="row gutters-tiny">
                        {data && data.images && data.images.map(item => (
                            <div className="col-6 col-sm-4 col-md-5 col-lg-4 col-xl-3">
                                <div className="options-container fx-item-zoom-in">
                                    <img className="img-fluid options-item" src={item.url} alt="" style={{ maxHeight: 215 }} />
                                    <div className="options-overlay bg-black-75">
                                        <div className="options-overlay-content">
                                            <a className="btn btn-sm btn-primary" href={item.url} target="_blank">
                                                <i className="fa fa-download mr-1"></i> Download
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <p className="font-size-sm text-muted pt-2">
                                    <i className="fa fa-paperclip"></i> {item.name}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {responses && responses.length === 0 ?
                <div className="text-center">
                    <h4>Em breve teremos um retorno sobre sua reclamação</h4>
                </div>
                : <div className="content-heading mb-0 pb-0">
                    ({responses.length}) Respostas
                    </div>}

            <ul class="timeline timeline-alt mt-0 mb-0" style={{ marginTop: -35 }}>
                {responses && responses.map(item => (
                    <li className="timeline-event mt-2 mb-3">
                        <div class="media">
                            <div className="mr-3 ml-3 overlay-container overlay-left">
                                <span className="overlay-item item item-tiny item-circle border border-2x border-white bg-success"></span>
                            </div>
                            <div className="block block-bordered block-fx-pop border-2x border-info" style={{ width: "100%" }}>
                                <div className="block-header pb-0">
                                    <div className="block-title pb-0">{item.user && item.user.level === UserHelper.UserLevel.Administrator ? "Equipe Reclame Rio": ""}</div>
                                </div>
                                <div className="block-content mb-3" style={{ whiteSpace: "pre-line" }}>
                                    {item.description} <br />
                                    <small>
                                        <i className="si si-calendar mr-1" /> {item && DateTranslate(item.createdDate)}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}